import { useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Button, Col, Input, Row, Space, Spin, Typography} from "antd";
import {useEffect, useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import OfficeTable from "./OfficeTable";
import {  useDeleteQuery, useGetQuery} from "../../service/query/Queries";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
const {Title}=Typography

const Office = () => {

    const navigate = useNavigate()
    const {mutate,isSuccess,isLoading:deleteLoading}=useDeleteQuery()
    const {data,isLoading:getLoading,refetch}=useGetQuery(false,'office-get',`/office` , false)
    const [search, setSearch] = useState([]);
    const [isSearch, setIsSearch] = useState(false);
    const ScreenMD = useBreakpoint().md;


    // delete
    const deleteHandle = (url, id) => {
        mutate({url, id});
    };
    useEffect(() => {
        refetch()
    }, [isSuccess]);

    // add
    const addArticle = () => {
        navigate('/office/add');
    };
    const searchFunc = (value) => {
        if (value === '') {
            setIsSearch(false);
        } else {
            setIsSearch(true);
        }
        const filterData = data?.filter(
            (data) => data?.name.toLowerCase().includes(value.toLowerCase()));
        setSearch(filterData);
    };

    return (
        <div className={'site-space-compact-wrapper'}>
            <Space direction={'vertical'} size={"large"} style={{width: '100%'}}>
                <Row gutter={[10 , 20]}>
                    <Col span={18}>
                        <Title className={'page--title'} level={2}>
                            Офис
                        </Title>
                    </Col>
                    {/*<FilterCompanyForAdmin/>*/}
                    <Col span={ 16 }>
                        <Input placeholder="Поиск офис" onChange={(e) => searchFunc(e.target.value)} />
                    </Col>
                    <Col span={8}>
                        <Button
                            type='primary'
                            icon={<PlusOutlined/>}
                            style={{width: '100%'}}
                            onClick={addArticle}>
                            {
                                ScreenMD && 'Добавить'
                            }
                        </Button>
                    </Col>

                </Row>
                <Spin
                    size='medium'
                    spinning={getLoading || deleteLoading}>
                    <OfficeTable
                        data={isSearch ? search : data}
                        deleteHandle={deleteHandle}
                    />
                </Spin>
            </Space>
        </div>
    );
};

export default Office;